export default "__VITE_ASSET__BSm8D6Ce__"